
import { useContext } from 'react'

import { FedContext } from '../../fed_plugins/_context/FedContext'

import { TVar, TVarType } from './TVar'

export function useFedVariables() {

    const config = useContext(FedContext)

    function getVar(path: string): TVar | undefined {
      if(config.variables === undefined)
        return
      const {context, field} = splitContext(path)
      const level = config.variables[context]
      if(level){
        return level.find(v => v.name === field)
      } else {
        return
      }
    }

    // empty is root
    function getVarChildren(path: string): TVar[] | null {
      if(config.variables === undefined)
        return null
      return config.variables[path];
    }

    function getVarType(path: string): TVarType {
      let v = getVar(path)
      if (!v)
        return '?'

      return v.type
    }

    return { getVar, getVarChildren, getVarType }
}

export const splitContext = (s: string):{context: string, field: string} => {
  const splits = s.split('.')
  const context = splits.slice(0, splits.length - 1).join('.')
  const field = splits[splits.length - 1]
  
  return {context, field}
}


